<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<p-fieldset>
    <ng-template pTemplate="header">{{translations.lbl_confirm}} {{translations.lbl_acquisition}}
        {{translations.lbl_of}} {{translations.lbl_rights}} {{translations.lbl_play}}</ng-template>
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <!-- <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="back()"></button> -->

            <button pButton pRipple label="{{translations.lbl_continue}}" class="p-button-success p-mr-2"
                (click)="continue()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN SCREEN -->
    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <!-- FORM -->
                    <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <!-- INPUT COORDINATION-->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_coordination}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedCoordination').value}}</span>
                        </div>

                        <!-- INPUT GUIDE -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_guide}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedGuide').value}}</span>
                        </div>

                        <!-- INPUT GUIDE -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_type}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedGuideType').value}}</span>
                        </div>

                        <!-- INPUT SERVICE -->
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_workshop}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedWorkshop').value}}</span>
                        </div>
                    </div>
                </p-panel>
            </div>
            <!-- <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                       
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1" *ngFor="let item of itemsList">
                            <span>{{translations.lbl_items_guides}}</span>
                            <span class="p-text-bold">
                                {{item.itemId}} - {{item.descri}}
                            </span>
                        </div>
                        <div *ngIf="itemsList.length < 2" class="p-py-4"></div>
                    </div>
                </p-panel>
            </div> -->
        </div>
    </div>

    <p-tabView>
        <!-- Futuros Guias -->
        <p-tabPanel [header]="translations.lbl_list + ' ' + translations.lbl_of + ' ' +translations.lbl_items">
            <p-table #dt1 [value]="futureGuidesList" styleClass="p-datatable-responsive-demo" dataKey="guideId"
                [globalFilterFields]="futureGuidesFilters" [columns]="futureGuidesCols" responsive="true"
                [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}"
                [rowsPerPageOptions]="[10,20,50]">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between">
                        <div>

                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{col.header}} <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th>
                            {{translations.lbl_actions}}
                        </th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-guide let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            <span class="p-column-title">{{col.header}}</span>
                            {{getLastField(guide,col.field)}}
                        </td>
                        <td>
                            <p-inputSwitch (onChange)="handleChange($event, guide)"
                                [(ngModel)]="guide.autorized"></p-inputSwitch>
                        </td>
                    </tr>
                </ng-template>
                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{futureGuidesList != null ? futureGuidesList.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</p-fieldset>